<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t("org.billing.Type Cost") }}</h4>
            </div>
        </div>
        <div class="b-table-sticky-header table-responsive">
            <b-table-simple
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th>
                            {{ $t('v4.Type') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Region') }}
                        </b-th>
                        <b-th
                            class="text-right text-nowrap"
                        >
                            {{ $t('v4.Amount') }}
                        </b-th>
                        <b-th
                            class="text-right text-nowrap"
                        >
                            {{ $t('v4.Cost') }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in list" :key="index">
                        <b-td>
                            {{ item.usageTypeGroup }}
                        </b-td>
                        <b-td>
                            {{ item.region }}
                        </b-td>
                        <b-td class="text-right">
                            {{ $_getAmount(item.amount, item.usageTypeGroup) }}
                        </b-td>
                        <b-td class="text-right text-nowrap">
                            {{ $_getDollar(item.cost) }}
                        </b-td>
                    </b-tr>
                    <b-tr v-if="noData">
                        <b-td colspan="4" class="pb-50 pt-2 text-center">
                            <SVGEmptyIcon/>
                            <div>

                                {{ $t("org.message.No Data") }}
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-card>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        },
        regionMap: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup (props, context) {
        const { data, regionMap } = toRefs(props)
        const noData = computed(() => !data.value.length)
        const usageTypeToRegionName = (usageType) => {
            const types = usageType.split('-')
            if (types.length) {
                const region = regionMap.value[types[0]]
                if (region && region.code === 'eu-west-1') {
                    return `${region.name} CDN`
                }
                return region?.name || 'N/A'
            } else {
                return 'N/A'
            }
        }
        const usageTypeToUsageTypeGroup = (usageType) => {
            if (usageType.indexOf('DataTransfer') > -1) {
                return 'DataTransfer'
            } else if (usageType.indexOf('Requests-Tier2-HTTPS') > -1) {
                return 'Requests - HTTPS'
            } else if (usageType.indexOf('Requests') > -1) {
                return 'Requests'
            } else {
                return usageType
            }
        }
        const dataMap = computed(() => {
            return data.value.reduce((acc, cur) => {
                const regionName = usageTypeToRegionName(cur.usageType)
                const usageTypeGroup = usageTypeToUsageTypeGroup(cur.usageType)
                if (!acc[regionName]) acc[regionName] = {}
                if (!acc[regionName][usageTypeGroup]) acc[regionName][usageTypeGroup] = { amount: 0, cost: 0 }
                acc[regionName][usageTypeGroup].amount += cur.usageAmount
                acc[regionName][usageTypeGroup].cost += cur.cost
                return acc
            }, {})
        })
        const list = computed(() => {
            const tableList = []
            for (const region in dataMap.value) {
                const item = dataMap.value[region]
                for (const usageTypeGroup in item) {
                    tableList.push({
                        usageTypeGroup,
                        region,
                        ...item[usageTypeGroup]
                    })
                }
            }
            return tableList
        })

        return {
            noData,
            dataMap,
            list
        }
    }
}
</script>

<style>

</style>
